"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));

var _Storyblok = _interopRequireDefault(require("../../../../utils/Storyblok"));

var _appRedirect = _interopRequireDefault(require("../../../../utils/appRedirect"));

var MuiMenuItem = function MuiMenuItem(_ref) {
  var redirectRoute = _ref.redirectRoute,
      buttonText = _ref.buttonText,
      rootClass = _ref.rootClass;

  var styles = _Storyblok.default.arrayToMuiStyles(rootClass);

  var redirect = function redirect() {
    return (0, _appRedirect.default)(redirectRoute);
  };

  return /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
    className: styles.root,
    onClick: redirect
  }, buttonText);
};

var _default = MuiMenuItem;
exports.default = _default;
MuiMenuItem.propTypes = {
  /** stroyblok multiselect of css classes */
  rootClass: _propTypes.default.arrayOf(_propTypes.default.string),

  /** button text */
  buttonText: _propTypes.default.string.isRequired,

  /** redirect route */
  redirectRoute: _propTypes.default.string.isRequired
};
MuiMenuItem.defaultProps = {
  rootClass: []
};